module.exports = "/images/gotham-1.jpg";